namespace Matrix {
    export interface EntityTypeItem {
        EntityType?: string;
        DisplayName?: string;
        InstanceName?: string;
        TableName?: string;
        Text?: string;
    }
}
